import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

// const header = (isFranchise = false) => [
//   { label: 'S.N', value: 'id' },
//   {
//     label: 'Date',
//     value: 'date',
//   },
//   {
//     label: 'Transaction id',
//     value: 'transactionId',
//   },

//   {
//     label: 'Type',
//     value: 'transactionType',
//   },
//   {
//     label: 'Supplied Qty',
//     value: 'supplied',
//   },
//   {
//     label: 'Amount',
//     value: 'amount',
//   },
//   {
//     label: 'Proof of Payment',
//     value: 'paymentProof',
//   },
//   {
//     label: 'Receipt',
//     value: 'receipt',
//   },
// ]
const header = (isFranchise = false) => [
  { label: 'S.N', value: 'id' },
  {
    label: 'Date',
    value: 'dd',
  },
  {
    label: 'Supply chain',
    value: 'scpic',
  },
  {
    label: 'Supplier',
    value: 'pickupPointName',
  },

  {
    label: 'feedstock',
    value: 'panmein',
  },
  {
    label: 'CATEGORY',
    value: 'catin',
  },
  {
    label: 'QUANTITY',
    value: 'qtin',
  },
  {
    label: 'GHG VALUE',
    value: 'inghg',
  },
  {
    label: 'RECIPIENT',
    value: 'erin',
  },
  {
    label: 'SD STATUS',
    value: 'inre',
  },
  {
    label: 'View',
    value: '',
  },
]

const roleColumns = (isFranchise = false) => {
  return columnGenerators(header(isFranchise))
}
export { roleColumns }
